<template>
  <component-wrapper>
    <div class="retailer-search-page-fi">
      <grid-container-fi v-if="!isAppView">
        <div class="fi-col-start-1 fi-col-end-13 lg:fi-col-start-4 lg:fi-col-end-10">
          <!-- eslint-disable vue/no-v-html -->
          <h1
            v-if="isEditMode"
            class="retailer-search-page-fi__headline"
            v-html="fields.retailerSearchHeadline?.editable"
          />
          <h1
            v-else
            class="retailer-search-page-fi__headline"
            v-html="fields.retailerSearchHeadline?.value"
          />
          <!-- eslint-enable vue/no-v-html -->
        </div>
      </grid-container-fi>

      <grid-container-fi :container="isSM">
        <div class="fi-col-start-1 fi-col-end-13 lg:fi-col-start-2 lg:fi-col-end-12">
          <retailer-search-fi
            :country-list="countryList[1]"
            :default-country="countryList[2]"
            :ranges="ranges"
            :default-range="defaultRange"
            retailer-search-page
          />
        </div>
      </grid-container-fi>
    </div>
  </component-wrapper>
</template>

<script setup lang="ts">
import { computed, defineAsyncComponent } from 'vue';

import ComponentWrapper from '@/components/component-wrapper/ComponentWrapper.vue';
import GridContainerFi from '@/components/grid-fi/GridContainerFi.vue';
import { useBreakpoints } from '@/composables/breakpoint';
import { useDistance } from '@/composables/distance';
import { useFields } from '@/composables/fields';
import { getSelectList } from '@/utils/fieldTransformations';

defineOptions({ name: 'RetailerSearchPageFi' });

const RetailerSearchFi = defineAsyncComponent(
  () => import('@/components/retailer-search-fi/RetailerSearchFi.vue'),
);

const fields = useFields('RetailerSearchPageFiFields');

const { isSM } = useBreakpoints();
const { unit } = useDistance();

const countryList = computed(() => getSelectList(fields, 'countryList', []));

const ranges = computed(() => {
  const result: { name: string; value: string }[] = [];
  if (fields?.retailerSearchRanges?.value) {
    fields.retailerSearchRanges.value.split(',').forEach((range: string) => {
      result.push({ name: `${range} ${unit.value}`, value: range });
    });
  }
  return result.length ? result : undefined;
});

const defaultRange = computed(() => {
  if (fields.retailerSearchDefaultRange?.value) {
    return fields.retailerSearchDefaultRange.value;
  }
  return undefined;
});
</script>

<style scoped src="./retailer-search-page-fi" />
